import _ from "underscore";
import { MobileActions } from "../../store/mobile/actions";
import { PictureSourceType, getFileController } from "../../utils/native/nativeFileApi";
import { getAndSaveNewImage, deleteImage } from "../../model/Image";
import PictureOptionDialog from "../framework/pictureOptionDialog";

import pageHTML from "./imageDebug.tmpl";
import DebugPageView from "./debugPageView";

export default class ImageDebug extends DebugPageView {
    private readonly template = _.template(pageHTML);

    /* eslint-disable @typescript-eslint/unbound-method */
    events() {
        return {
            "click #takePicture": this.takePicture,
            "click #uploadPicture": this.uploadPicture,
            "click #openPictureDialog": this.openPictureDialog,
            "click #viewExistingImages": this.viewExistingImages,
            "click #deleteAllImages": this.deleteAllImages,
            "click #addTestImage": this.addTestImage,
            "click #deleteTestImage": this.deleteTestImage
            } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */

    render() {
        this.el.innerHTML = this.template({ hasTestImage: window.driveApp.debug?.base64TestImage });

        this.app.store.dispatch(MobileActions.setPageState({
            title: "ImageDebug",
            pageLevel: 2
        }));

        return this;
    }

    loadExistingImages(): void {
        let existingImages = this.app.store.getState().data.images;
        let promises = [] as any;

        for (let entityId in existingImages) {
            promises.push(getFileController().getBase64Data(existingImages[entityId].path));
        }

        Promise.all(promises).then((imagesBinaryData) => {
            for (let i = 0; i < imagesBinaryData.length; i++) {
                this.appendImage(imagesBinaryData[i] as string);
            }
            console.log("Loaded all images");
        }).catch((e: Error) => {
            console.error(e.message);
        });
    }

    takePicture(): void {
        this.getAndSavePicture(PictureSourceType.CAMERA);
    }

    uploadPicture(): void {
        this.getAndSavePicture(PictureSourceType.PHOTOLIBRARY);
    }

    openPictureDialog(): void {
        let pictureDialog = new PictureOptionDialog(this.app.translationService.getTranslator(), this.app.store, false);
        void pictureDialog.open("", undefined);
    }

    getAndSavePicture(source: PictureSourceType): void {
        getAndSaveNewImage(source, this.app.store, "", false, undefined).catch((error: Error) => console.error(error.message));
    }

    viewExistingImages() {
        this.loadExistingImages();
    }

    deleteAllImages() {
        let existingImages = this.app.store.getState().data.images;
        let promises = [] as any;

        for (let entityId in existingImages) {
            promises.push(deleteImage(this.app.store, existingImages[entityId].path));
        }

        Promise.all(promises).then(() => {
            console.log("Deleted all images");
            this.render();
        }).catch((e: Error) => {
            console.error(e.message);
        });
    }

    appendImage(imageData: string): void {
        let element = document.createElement("img");
        element.setAttribute("src", imageData);
        element.setAttribute("height", "500");
        element.setAttribute("width", "500");
        (document as any).getElementById("images").appendChild(element);
    }

    addTestImage() {
        if (window.driveApp.debug) {
            window.driveApp.debug.base64TestImage = "img";
        }
        this.render();
    }

    deleteTestImage() {
        if (window.driveApp.debug) {
            window.driveApp.debug.base64TestImage = "";
        }
        this.render();
    }
}